<template>
	<div>
		<!-- Label -->
		<div class="flex xs-12 xs-between">
			<label class="fs3 c6 fw6 mb1">{{ $t("insurance_type") }}</label>
			<div v-if="value.length > 0" class="fs3 cu2 cError" @click="handleReset">
				{{ $t("clear") }}
			</div>
		</div>

		<j-base-multi-select-with-flexible-value
			:value="value"
			:allowLocalSearch="true"
			:options="options"
			:size="size"
			:placeholder="$t('select')"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue/"
import api from "../../api/"
export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: ["value", "size"],
	data() {
		return {
			options: []
		}
	},
	methods: {
		handleReset() {
			this.$emit("input", [])
		},
		async readAllInsuranceTypes() {
			const res = await api.insuranceTypes()
			this.options = res.data.productTypes.map(item => ({
				name: item.name,
				value: item.typeId
			}))

			this.options.sort((a, b) => {
				let nameA = a?.name?.toUpperCase()
				let nameB = b?.name?.toUpperCase()

				if (nameA < nameB) return -1
				if (nameA > nameB) return 1

				return 0
			})
		}
	},
	created() {
		this.readAllInsuranceTypes()
	}
}
</script>
